export default __webpack_public_path__ + "static/media/DIY10.86c7e344.JPG";